(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[949],{

/***/ 5550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ JobApplyButton; }
});

// UNUSED EXPORTS: AppliedMsg

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var build = __webpack_require__(6680);
// EXTERNAL MODULE: ./src/utils/ApplyButtonTextExperiment.ts
var ApplyButtonTextExperiment = __webpack_require__(2509);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/CheckMark.tsx
var CheckMark = __webpack_require__(5569);
// EXTERNAL MODULE: ./src/utils/appcast.ts
var appcast = __webpack_require__(5425);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
;// CONCATENATED MODULE: ./src/utils/cookies.ts

// These only work inside the browser

/**
 * Retrieve an existing cookie or an empty string.
 */ var get = function(name) {
    var r = document.cookie.match("\\b".concat(name, "=([^;]*)\\b"));
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */ var set = function(name, value) {
    var days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(0,browser/* isBrowser */.jU)()) {
        return "";
    }
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(date.toUTCString());
    }
    document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires, ";path=/");
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */ var remove = function(name) {
    set(name, "", -1);
};
var parse = function() {
    var cookies = {};
    document.cookie.split(";").forEach(function(cookie) {
        var ref = (0,_sliced_to_array/* default */.Z)(cookie.trim().split("="), 2), key = ref[0], value = ref[1];
        cookies[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return cookies;
};
var Cookies = {
    remove: remove,
    get: get,
    parse: parse,
    set: set
};
/* harmony default export */ var cookies = (Cookies);

;// CONCATENATED MODULE: ./src/utils/externalJobApply.ts


var cookieKey = "external_job_ids_list";
/**
 * Retrieve and decode the job object from the cookie.
 */ var getJobObject = function() {
    var cookie = cookies.get(cookieKey);
    var decodedData = window.atob(cookie.toString());
    var jobObject = JSON.parse(decodedData || "{}");
    return jobObject;
};
/**
 * Inject a new job ID and dedupe the list.
 */ var updateJobList = function(list, id) {
    list.push(id);
    var newList = list.filter(function(x, index) {
        return list.indexOf(x) === index;
    });
    return newList;
};
/**
 * Creat or update the jobs object.
 */ var setJobObject = function(companyId, jobId) {
    var jobObject = getJobObject();
    jobObject[companyId] = jobObject[companyId] ? updateJobList(jobObject[companyId], jobId) : [
        jobId
    ];
    var encryptedJobs = window.btoa(JSON.stringify(jobObject));
    return encryptedJobs;
};
/**
 * Sets a cookie with the encrypted companies and jobs applied to by this session within the last 30 days.
 */ var externalJobApply = function(companyId, jobId) {
    if (!(0,browser/* isBrowser */.jU)()) {
        return;
    }
    var jobObject = setJobObject(companyId, jobId);
    cookies.set(cookieKey, jobObject, 30);
};


// EXTERNAL MODULE: ./src/utils/interactionHistory.ts
var interactionHistory = __webpack_require__(2184);
// EXTERNAL MODULE: ./src/components/JobApplyButton.module.scss
var JobApplyButton_module = __webpack_require__(7134);
var JobApplyButton_module_default = /*#__PURE__*/__webpack_require__.n(JobApplyButton_module);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 5 modules
var AppContext = __webpack_require__(6833);
;// CONCATENATED MODULE: ./src/components/JobApplyButton.tsx













/**
 * Renders a message indicating that the job has been applied.
 *
 * @param {Object} props - The component props.
 * @param {number} props.interactionDate - The date of the interaction in milliseconds.
 * @returns {ReactElement} - The rendered component.
 */ var AppliedMsg = function(props) {
    var interactionDate = props.interactionDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (JobApplyButton_module_default()).jobInteractionHistoryApply,
        children: [
            "Applied ",
            (0,interactionHistory/* getInteractionDate */.V0)(interactionDate),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckMark/* default */.Z, {})
        ]
    });
};
/**
 * Renders a message indicating whether the user should use their saved information and resume.
 * @returns {ReactElement} - The rendered component or null.
 */ var StoredMsg = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (JobApplyButton_module_default()).jobInteractionUserData,
        children: "Use your saved info and resume"
    });
});
StoredMsg.displayName = "StoredMsg";
/**
 * Renders a button component for job application.
 *
 * @param {JobApplyButtonProps} props - The props for the JobApplyButton component.
 * @param {string} props.className - The class name for the button component.
 * @param {number} props.jobId - The ID of the job.
 * @param {IMetadataObj} props.trackingProps - The tracking properties for the button.
 * @param {(x: boolean) => void} props.setIsOpen - The function to set the open state of a modal.
 * @param {boolean} props.isDirectApply - { deprecated } A flag indicating if it is a direct apply button.
 * @returns {ReactElement} The rendered JobApplyButton component.
 */ var JobApplyButton = function(props) {
    var job = (0,AppContext/* useAppState */.mr)().job;
    var state = job.state;
    var className = props.className, jobId = props.jobId, trackingProps = props.trackingProps;
    var ref = (0,react.useState)(""), redirectUrl = ref[0], setRedirectUrl = ref[1];
    var ref1 = (0,react.useState)(null), interactionDate = ref1[0], setInteractionDate = ref1[1];
    var ref2 = (0,react.useState)(false), showApplied = ref2[0], setShowApplied = ref2[1];
    var ref3 = (0,react.useState)(false), showStored = ref3[0], setShowStored = ref3[1];
    var experiments = (0,build.useExperimentState)().experiments;
    var buttonText = (0,react.useMemo)(function() {
        return (0,ApplyButtonTextExperiment/* getApplyButtonText */.p)(state, "", experiments, build.getActiveVariant);
    }, [
        state,
        experiments
    ]);
    var targetPageSection = "off_site";
    var trackingClass = "track-job-apply-button";
    var ref4, ref5, ref6, ref7, ref8, ref9;
    var snowplowTrackingProps = {
        sp_click_button_text: (ref4 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_click_button_text) !== null && ref4 !== void 0 ? ref4 : buttonText,
        sp_click_button_type: (ref5 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_click_button_type) !== null && ref5 !== void 0 ? ref5 : "apply",
        sp_click_component: "button",
        sp_click_position: (ref6 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_click_position) !== null && ref6 !== void 0 ? ref6 : "bottom",
        sp_click_target_page_section: (ref7 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_click_target_page_section) !== null && ref7 !== void 0 ? ref7 : targetPageSection,
        sp_experiment_experiment_id: (ref8 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_experiment_experiment_id) !== null && ref8 !== void 0 ? ref8 : null,
        sp_experiment_variant_id: (ref9 = trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.sp_experiment_variant_id) !== null && ref9 !== void 0 ? ref9 : null
    };
    /**
     * Handles the click event for the job apply button.
     */ var linkHandler = function() {
        externalJobApply(trackingProps.company_id, trackingProps.jobId);
        (0,appcast/* appCastJobApply */.N)();
        window.open(redirectUrl, "_blank");
    };
    var btnProps = {
        className: "".concat(className, " ").concat(trackingClass),
        onClick: linkHandler,
        color: "secondary-100",
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify(snowplowTrackingProps),
        target: "_blank"
    };
    if (showApplied) {
        btnProps.disabled = true;
    }
    (0,react.useEffect)(function() {
        setRedirectUrl("/job/redirect/".concat(jobId).concat(window.location.search));
        (0,interactionHistory/* setInteractionViewed */.QP)(jobId);
        /**
         * Retrieves the apply status for a job.
         */ var checkApplyStatus = function() {
            var lastInteraction = (0,interactionHistory/* getJobLastInteraction */.xy)(jobId);
            var isApplicant = (0,interactionHistory/* getApplicant */.h$)();
            if (lastInteraction) {
                setInteractionDate(lastInteraction === null || lastInteraction === void 0 ? void 0 : lastInteraction.dt);
                setShowApplied(lastInteraction === null || lastInteraction === void 0 ? void 0 : lastInteraction.app);
                setShowStored(isApplicant && !(lastInteraction === null || lastInteraction === void 0 ? void 0 : lastInteraction.app));
            }
        };
        checkApplyStatus();
        // watch for storage changes
        window.addEventListener("storage", checkApplyStatus);
        return function() {
            window.removeEventListener("storage", checkApplyStatus);
        };
    }, [
        interactionDate,
        jobId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, btnProps), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: showApplied ? "APPLIED" : buttonText
                })
            })),
            showStored && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoredMsg, {}),
            showApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppliedMsg, {
                interactionDate: interactionDate
            })
        ]
    });
};


/***/ }),

/***/ 9116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ JobIndividualBody; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 5 modules
var AppContext = __webpack_require__(6833);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/components/JobApplyButton.tsx + 2 modules
var JobApplyButton = __webpack_require__(5550);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/components/JobIndividualBody.module.scss
var JobIndividualBody_module = __webpack_require__(6766);
var JobIndividualBody_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualBody_module);
;// CONCATENATED MODULE: ./src/components/JWPlayerVideoModule.tsx






var installPlayerScript = function(param) {
    var onLoadCallback = param.onLoadCallback, scriptSrc = param.scriptSrc, uniqueScriptId = param.uniqueScriptId;
    var jwPlayerScript = document.createElement("script");
    jwPlayerScript.id = uniqueScriptId;
    jwPlayerScript.src = scriptSrc;
    jwPlayerScript.defer = true;
    jwPlayerScript.onload = onLoadCallback;
    document.head.appendChild(jwPlayerScript);
};
var JWPlayerVideoModule = function(props) {
    var title = props.title, description = props.description, tagName = props.tagName, excludeTag = props.excludeTag;
    var playerRef = (0,react.useRef)();
    var playerWrapperRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), playerScriptInitialized = ref[0], setPlayerScriptInitialized = ref[1];
    var ref1 = (0,react.useState)(null), jwplayerInstance = ref1[0], setJwplayerInstance = ref1[1];
    var ref2 = (0,react.useState)(null), trackingProps = ref2[0], setTrackingProps = ref2[1];
    var firstView = (0,react.useRef)(false);
    var exclude = excludeTag ? "&exclude_tags=Hiring+Manager+Video" : "";
    (0,react.useEffect)(function() {
        installPlayerScript({
            onLoadCallback: function() {
                setPlayerScriptInitialized(true);
            },
            scriptSrc: "https://cdn.jwplayer.com/libraries/OOgy074L.js",
            uniqueScriptId: "jdp-jwplayer-instance"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (playerScriptInitialized) {
            var instance = window.jwplayer(playerRef.current).setup({
                playlist: "https://cdn.jwplayer.com/v2/playlists/5lLe5BiO?tags=".concat(tagName).concat(exclude),
                mute: true
            });
            setJwplayerInstance(instance);
        }
    }, [
        playerScriptInitialized,
        exclude,
        tagName
    ]);
    (0,react.useEffect)(function() {
        var dataTrackingProps = {
            sp_impression_component: "insert",
            sp_impression_insert_type: "media",
            sp_impression_position: "bottom",
            sp_search_id: "null",
            sp_media_type: "video",
            sp_media_id: null,
            sp_media_name: null,
            sp_media_provider_key: null,
            sp_media_provider_name: "jwplayer"
        };
        if (jwplayerInstance !== null) {
            jwplayerInstance.on("ready", function() {
                var playlist = jwplayerInstance.getPlaylist();
                setTrackingProps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataTrackingProps), {
                    sp_media_id: playlist[0].mediaid,
                    sp_media_name: playlist[0].title,
                    sp_media_provider_key: "".concat(playlist[0].feedid, "-").concat(tagName)
                }));
            });
        }
    }, [
        jwplayerInstance,
        tagName
    ]);
    (0,react.useEffect)(function() {
        if (jwplayerInstance && trackingProps) {
            jwplayerInstance.on("viewable", function() {
                // The viewable event is bugged, so we add a getViewable check
                if (!firstView.current && jwplayerInstance.getViewable()) {
                    (0,build.triggerSnowplowImpressionEvent)(playerWrapperRef.current);
                    firstView.current = true;
                }
            });
            jwplayerInstance.on("play", function() {
                (0,build.triggerSnowplowVideoEvent)("play", playerWrapperRef.current);
            });
        }
    }, [
        jwplayerInstance,
        trackingProps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualBody_module_default()).jobBodyJWPlayerVideo,
        ref: playerWrapperRef,
        "data-tracking-props": JSON.stringify(trackingProps),
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }) : null,
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: playerRef
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/icons/HealthAndWellnessIcon.tsx




/* eslint-disable max-len */ 
var HealthAndWellnessIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.94,6a1.1,1.1,0,0,0-.32-.78,1.14,1.14,0,0,0-.78-.32H11.53V1.6a1.14,1.14,0,0,0-.32-.78A1.14,1.14,0,0,0,10.43.5H6a1.14,1.14,0,0,0-.78.32,1.14,1.14,0,0,0-.32.78V4.91H1.6a1.14,1.14,0,0,0-.78.32A1.14,1.14,0,0,0,.5,6v4.42a1.14,1.14,0,0,0,.32.78,1.14,1.14,0,0,0,.78.32H4.91v3.31a1.14,1.14,0,0,0,.32.78,1.1,1.1,0,0,0,.78.32h4.42a1.1,1.1,0,0,0,.78-.32,1.14,1.14,0,0,0,.32-.78V11.53h3.31a1.14,1.14,0,0,0,.78-.32,1.1,1.1,0,0,0,.32-.78Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/FinanceIcon.tsx




/* eslint-disable max-len */ 
var FinanceIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 20 17.3",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.68,12.09a5.67,5.67,0,0,0,1.67-1.94A5.8,5.8,0,0,0,16,7.67C16,4.32,12.72,1.6,8.7,1.6a8.44,8.44,0,0,0-2.35.33A4,4,0,0,0,4.52.53a.4.4,0,0,0-.24,0,.53.53,0,0,0-.22.08A.55.55,0,0,0,3.9.77a.59.59,0,0,0,0,.23V3.17A5.33,5.33,0,0,0,2,5.56H1a.5.5,0,0,0-.51.5v3a.47.47,0,0,0,.15.35A.48.48,0,0,0,1,9.6H2a5.93,5.93,0,0,0,2,2.72L3.43,14a1.23,1.23,0,0,0,0,1,1.55,1.55,0,0,0,.28.39,1.33,1.33,0,0,0,.41.25,1.15,1.15,0,0,0,.48.07,1.12,1.12,0,0,0,.47-.11,1.33,1.33,0,0,0,.38-.29,1.18,1.18,0,0,0,.24-.42l.56-1.5a8.52,8.52,0,0,0,5.26-.11l.59,1.61a1.27,1.27,0,0,0,.25.42,1.2,1.2,0,0,0,.38.29,1.31,1.31,0,0,0,.47.12,1.09,1.09,0,0,0,.47-.08,1,1,0,0,0,.41-.25,1.08,1.08,0,0,0,.28-.39,1.12,1.12,0,0,0,.11-.47,1.36,1.36,0,0,0-.09-.48Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.38,5.8A4.7,4.7,0,0,0,9.31,4.24",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16,7.67c1.62,0,2.43-.81,2.43-2",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.42,5.38a1,1,0,0,1,1,.64,1,1,0,0,1,.06.6,1.08,1.08,0,0,1-.28.54,1.06,1.06,0,0,1-.54.29A1.12,1.12,0,0,1,5,7.39,1.06,1.06,0,0,1,4.55,7a1,1,0,0,1-.18-.58,1,1,0,0,1,.31-.74A1.05,1.05,0,0,1,5.42,5.38Z",
                fill: "#666"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/OfficeLifeIcon.tsx




/* eslint-disable max-len */ 
var OfficeLifeIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 20 21.76",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.11,9.58h1.12a2,2,0,0,1,1.58.88,3.7,3.7,0,0,1,0,4.22,2,2,0,0,1-1.58.87H13.07",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M.86,7.21h12a.36.36,0,0,1,.36.36V16a2.24,2.24,0,0,1-2.24,2.24H2.74A2.24,2.24,0,0,1,.5,16V7.57A.36.36,0,0,1,.86,7.21Z",
                fill: "#d8f0e9",
                stroke: "#666"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33.5l.94.79a.76.76,0,0,1,.22.28.8.8,0,0,1,.07.34.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79A.77.77,0,0,0,8,4a.84.84,0,0,0,.07.35.85.85,0,0,0,.22.28l.58.49",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.76.5l.94.79a.76.76,0,0,1,.22.28A.8.8,0,0,1,6,1.91a.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79a.76.76,0,0,0-.22.28A.77.77,0,0,0,4.46,4a.82.82,0,0,0,.3.63l.58.49",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/ProfessionalDevelopmentIcon.tsx




/* eslint-disable max-len */ 
var ProfessionalDevelopmentIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 20 18.38",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.62,15.11V2.55S6.84.58.87.5a.35.35,0,0,0-.14,0A.32.32,0,0,0,.61.61.36.36,0,0,0,.5.87V12.69A.42.42,0,0,0,.6,13a.36.36,0,0,0,.26.11C6.84,13.14,8.62,15.11,8.62,15.11Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.62,15.11V2.55s1.77-2,7.74-2a.35.35,0,0,1,.14,0,.25.25,0,0,1,.12.08.36.36,0,0,1,.11.26V12.69a.42.42,0,0,1-.1.26.36.36,0,0,1-.26.11C10.39,13.14,8.62,15.11,8.62,15.11Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.69,4a.5.5,0,0,0-.07,1,14.86,14.86,0,0,1,3.67.74.52.52,0,0,0,.64-.32.51.51,0,0,0-.32-.63A15.86,15.86,0,0,0,2.69,4Zm0,4a.5.5,0,0,0-.07,1,14.84,14.84,0,0,1,3.67.73.51.51,0,0,0,.64-.31.52.52,0,0,0-.32-.64A15.85,15.85,0,0,0,2.69,8ZM15.07,4.42a.5.5,0,0,1-.46.53,14.86,14.86,0,0,0-3.67.74.5.5,0,0,1-.63-.32.5.5,0,0,1,.31-.63A15.86,15.86,0,0,1,14.54,4,.5.5,0,0,1,15.07,4.42ZM14.61,9a.5.5,0,0,0-.07-1,15.85,15.85,0,0,0-3.92.78.51.51,0,0,0-.31.64.49.49,0,0,0,.63.31A14.84,14.84,0,0,1,14.61,9Z",
                fill: "#666",
                fillRule: "evenodd"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/VacationAndTimeOffIcon.tsx




/* eslint-disable max-len */ 
var VacationAndTimeOffIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 20 18.03",
        fill: "none",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.15,6.46a1,1,0,0,0,.36-.23,1,1,0,0,0,.21-.37.9.9,0,0,0,0-.43A.88.88,0,0,0,17.56,5,9.07,9.07,0,0,0,1.4,10.66a.87.87,0,0,0,.1.42.79.79,0,0,0,.28.32.83.83,0,0,0,.4.16.75.75,0,0,0,.42,0Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.94.5l.44,1.21",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.43,13.57l-1-2.84L10,9.32",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M.5,16.6a4.44,4.44,0,0,0,2-.19,4.43,4.43,0,0,0,1.67-1,3.66,3.66,0,0,0,1.23.9,3.82,3.82,0,0,0,1.49.31,3.74,3.74,0,0,0,1.48-.31,3.66,3.66,0,0,0,1.23-.9,3.87,3.87,0,0,0,1.23.9,3.74,3.74,0,0,0,3,0,3.76,3.76,0,0,0,1.23-.9,4.38,4.38,0,0,0,3.62,1.21",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/DiversityAndInclusionIcon.tsx




/* eslint-disable max-len */ 
var DiversityAndInclusionIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.925 4.27h4.797v6.927h-4.364l-1.062.59-2.83 2.508H4.86l-.667-.905-.316-1.69c-.015-.438-2.87 0-2.24-1.887-.315-1.299 1.809-.853 1.799-1.299-.01-.417-1.486-.703-1.486-1.617C1.51 5.884 3.788 5.83 3.437 5.29c-.321-.492-.787-.627-.778-1.376.012-.912 1.54-1.029 1.612-1.1.22-.22 5.622-.092 8.296 0 .707.485 2.17 1.454 2.358 1.454Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.026 11.351v1.443a1.443 1.443 0 0 0 1.443 1.444h6.31l2.704-2.224a1.939 1.939 0 0 1 1.443-.721H19.9m0-7.157h-5.05l-2.165-1.443H4.748c-2.742 0-2.654 2.742-1.113 2.742h-.163a1.508 1.508 0 1 0 0 3.016h-.645a1.465 1.465 0 0 0-1.443 1.247 1.443 1.443 0 0 0 1.422 1.653h5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.673 14.326v4.796h-6.928v-4.364l-.59-1.061-2.508-2.83V4.26l.905-.667 1.69-.316c.438-.014 0-2.87 1.887-2.24 1.299-.315.853 1.809 1.299 1.799.417-.01.703-1.486 1.617-1.486 1.013-.441 1.067 1.838 1.606 1.486.492-.32.627-.786 1.375-.777.913.011 1.03 1.54 1.101 1.612.22.22.092 5.622 0 8.295-.485.708-1.454 2.17-1.454 2.359Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.59 3.427h-1.442a1.443 1.443 0 0 0-1.444 1.443v6.309l2.224 2.704a1.938 1.938 0 0 1 .722 1.443V19.3m7.156 0v-5.05l1.443-2.165V4.148c0-2.742-2.742-2.653-2.742-1.112v-.163a1.508 1.508 0 0 0-3.016 0v-.645A1.465 1.465 0 0 0 24.244.785a1.443 1.443 0 0 0-1.653 1.42v5.551",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.812 29.326h-4.797v-6.928h4.364l1.062-.59 2.83-2.507h6.605l.668.904.315 1.69c.015.438 2.87 0 2.241 1.887.315 1.299-1.81.854-1.8 1.299.01.417 1.486.703 1.486 1.617.442 1.013-1.837 1.067-1.485 1.606.32.492.786.627.777 1.376-.011.912-1.54 1.03-1.612 1.1-.22.22-5.622.092-8.295 0-.708-.484-2.17-1.454-2.36-1.454Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.71 22.244V20.8a1.443 1.443 0 0 0-1.442-1.443h-6.31l-2.703 2.223a1.938 1.938 0 0 1-1.444.722h-3.974m0 7.156h5.05l2.165 1.443h7.937c2.742 0 2.654-2.742 1.113-2.742h.163a1.508 1.508 0 0 0 0-3.016h.645a1.465 1.465 0 0 0 1.443-1.246 1.443 1.443 0 0 0-1.421-1.654h-5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.943 19.525V14.73h5.544v4.108l.59 1.061 3.892 2.831v6.605l-.905.667-1.69.316c-.438.014 0 2.87-1.887 2.24-1.299.315-.854-1.809-1.299-1.799-.417.01-.703 1.486-1.617 1.486-1.013.441-1.067-1.837-1.606-1.486-.492.321-.627.787-1.376.777-.912-.01-1.03-1.54-1.1-1.611-.22-.22-.092-5.622 0-8.296.484-.707 1.454-1.914 1.454-2.103Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.913 30.168h1.443a1.443 1.443 0 0 0 1.443-1.443v-6.309l-3.607-2.704a1.937 1.937 0 0 1-.722-1.443v-3.974m-5.772 0v5.05L4.255 21.51v7.937c0 2.742 2.742 2.654 2.742 1.112v.163a1.508 1.508 0 1 0 3.016 0v.646a1.465 1.465 0 0 0 1.246 1.443 1.443 1.443 0 0 0 1.654-1.422v-5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/ParentalIcon.tsx




/* eslint-disable max-len */ 
var ParentalIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.25 20.992a3.75 3.75 0 0 0-2.84-3.637A14.85 14.85 0 0 0 18 4.492 14.85 14.85 0 0 0 3.59 17.355a3.75 3.75 0 0 0 .548 7.37A14.7 14.7 0 0 0 18 35.241a14.7 14.7 0 0 0 13.861-10.518 3.75 3.75 0 0 0 3.389-3.732Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 4.492c.936.018 2.561.03 3.25.665 0 0 .391.455.485 1.386a3.061 3.061 0 0 1-2.738 3.352 2.446 2.446 0 0 1-2.68-2.19 1.904 1.904 0 0 1 .033-.628M14.25 18.102c0 .932-1.008 1.688-2.25 1.688s-2.25-.75-2.25-1.688M21.75 18.102c0 .932 1.008 1.688 2.25 1.688s2.25-.75 2.25-1.688M14.48 26.352a4.11 4.11 0 0 0 3.52 1.5 4.11 4.11 0 0 0 3.52-1.5",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 4.492a14.85 14.85 0 0 1 14.41 12.863 3.75 3.75 0 0 1-.548 7.37A14.7 14.7 0 0 1 18 35.241 14.7 14.7 0 0 1 4.138 24.724a3.75 3.75 0 0 1-.549-7.37A14.85 14.85 0 0 1 18 4.493Zm0 0c.936.018 2.561.03 3.25.665 0 0 .391.455.485 1.386a3.061 3.061 0 0 1-2.738 3.352 2.446 2.446 0 0 1-2.68-2.19 1.904 1.904 0 0 1 .033-.628m-2.1 11.025c0 .932-1.008 1.688-2.25 1.688s-2.25-.75-2.25-1.688m12 0c0 .932 1.008 1.688 2.25 1.688s2.25-.75 2.25-1.688m-11.77 8.25a4.11 4.11 0 0 0 3.52 1.5 4.11 4.11 0 0 0 3.52-1.5",
                stroke: "#666",
                fill: "#D8F0E9",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/FlexibleIcon.tsx




/* eslint-disable max-len */ 
var FlexibleIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.805 23.688V11.376a1.894 1.894 0 0 0-1.894-1.894H15.233l-.942 2.353c-1.095 1.361-1.33 2.021-3.592 2.955-2.348.664-2.624.468-2.624.468v8.43h22.73Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.484 29.548a1.895 1.895 0 0 1-1.731 2.664H7.129a1.895 1.895 0 0 1-1.732-2.664l2.678-5.86h22.73l2.68 5.86ZM8.13 15.258a7.256 7.256 0 0 0 7.254-7.253 7.254 7.254 0 1 0-7.254 7.253Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.13 5.118v2.901l1.741 1.74",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m14.291 11.835.39.313a.498.498 0 0 0 .074-.127l-.464-.186ZM10.7 14.79l.136.481a.477.477 0 0 0 .055-.019l-.19-.462Zm22.785 14.758.457-.203-.002-.005-.455.208Zm-1.731 2.664v-.5.5Zm-24.624 0v-.5.5Zm-1.732-2.664-.454-.207-.003.004.457.203Zm12.15-1.625a.5.5 0 0 0 0 1v-1Zm3.788 1a.5.5 0 0 0 0-1v1ZM8.63 5.118a.5.5 0 0 0-1 0h1Zm-.5 2.901h-.5a.5.5 0 0 0 .147.354l.353-.354Zm1.388 2.094a.5.5 0 0 0 .707-.707l-.707.707Zm-1.443 5.145.288-.408a.5.5 0 0 0-.788.408h.5Zm23.23 8.43V11.376h-1v12.312h1Zm0-12.312c0-.635-.252-1.244-.701-1.693l-.707.707c.261.261.408.616.408.986h1Zm-.701-1.693a2.394 2.394 0 0 0-1.693-.701v1c.37 0 .724.147.986.408l.707-.707ZM8.074 24.188h22.73v-1H8.075v1Zm24.953 5.563c.094.213.134.445.116.677l.997.079a2.393 2.393 0 0 0-.199-1.162l-.914.406Zm.116.677a1.394 1.394 0 0 1-.221.65l.838.544c.218-.334.348-.718.38-1.115l-.997-.08Zm-.221.65c-.127.194-.3.354-.504.465l.477.879c.35-.19.648-.465.865-.8l-.838-.545Zm-.504.465c-.204.11-.433.169-.665.169v1c.399 0 .791-.1 1.142-.29l-.477-.88Zm-.665.169H7.129v1h24.624v-1Zm-24.624 0c-.233 0-.461-.058-.665-.17l-.477.88c.35.19.743.29 1.142.29v-1Zm-.665-.17a1.395 1.395 0 0 1-.504-.465l-.839.545c.218.335.515.61.866.8l.477-.88Zm-.504-.465a1.395 1.395 0 0 1-.221-.65l-.997.08c.031.397.162.78.38 1.115l.838-.545Zm-.221-.65a1.394 1.394 0 0 1 .115-.676l-.914-.406c-.162.365-.23.764-.198 1.162l.997-.08Zm.113-.67 2.678-5.861-.91-.416-2.677 5.86.91.416Zm24.498-5.861 2.68 5.86.909-.416-2.68-5.86-.909.416Zm-12.803 5.027h3.788v-1h-3.788v1ZM8.13 14.758a6.753 6.753 0 0 1-6.753-6.753h-1a7.753 7.753 0 0 0 7.753 7.753v-1ZM1.377 8.005A6.754 6.754 0 0 1 8.13 1.25v-1A7.754 7.754 0 0 0 .377 8.005h1ZM8.13 1.25a6.753 6.753 0 0 1 6.754 6.754h1A7.753 7.753 0 0 0 8.13.25v1Zm-.5 3.867v2.901h1V5.118h-1Zm.147 3.255 1.74 1.74.708-.707-1.741-1.74-.707.707Zm6.125 3.149c-.585.726-.867 1.166-1.312 1.588-.42.395-.984.765-2.081 1.218l.381.924c1.165-.48 1.849-.908 2.386-1.416.511-.482.894-1.053 1.405-1.688l-.78-.627Zm-3.338 2.787c-1.162.328-1.785.436-2.104.466-.16.015-.228.009-.242.007-.006 0 .007 0 .031.009a.39.39 0 0 1 .112.057c.001 0 .002.002-.286.41-.289.408-.288.41-.286.41l.002.002.004.002c.003.002.006.005.01.006a.405.405 0 0 0 .054.031.833.833 0 0 0 .233.065c.11.014.258.016.461-.003.407-.039 1.096-.165 2.282-.5l-.272-.962Zm-2.99.949v8.43h1v-8.43h-1Zm7.31-7.253c0 .472-.049.932-.14 1.375l.979.203c.105-.51.16-1.038.16-1.578h-1Zm-.14 1.375a6.756 6.756 0 0 1-6.614 5.378v1a7.756 7.756 0 0 0 7.593-6.175l-.98-.203Zm14.167-.398H15.233v1h13.678v-1Zm-14.142.314-.942 2.353.928.372.942-2.354-.928-.371Z",
                fill: "#666"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/PerksAndBenefits.tsx

/* eslint-disable camelcase */ 









var iconKeys = {
    finance: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceIcon, {}),
    health_and_wellness: /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthAndWellnessIcon, {}),
    office_life: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeLifeIcon, {}),
    professional_development: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalDevelopmentIcon, {}),
    vacation_and_timeoff: /*#__PURE__*/ (0,jsx_runtime.jsx)(VacationAndTimeOffIcon, {}),
    parental_benefits: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentalIcon, {}),
    work_flexibility: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexibleIcon, {}),
    diversity_and_inclusion: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiversityAndInclusionIcon, {})
};
var PerksAndBenefits = function(props) {
    var company = props.company;
    var perks_and_benefits = company.perks_and_benefits;
    var hasPerksOrBenefits = perks_and_benefits ? Object.keys(perks_and_benefits).reduce(function(pbCount, pbKey) {
        return pbCount + perks_and_benefits[pbKey].perks.length;
    }, 0) > 0 : false;
    return hasPerksOrBenefits ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualBody_module_default()).perksAndBenefits,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Perks and Benefits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: Object.keys(perks_and_benefits).map(function(perkName) {
                    var ref, ref1;
                    return ((ref = perks_and_benefits[perkName]) === null || ref === void 0 ? void 0 : (ref1 = ref.perks) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            iconKeys[perkName],
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: perks_and_benefits[perkName].name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: perks_and_benefits[perkName].perks.map(function(perkOrBenefit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: perkOrBenefit.name
                                    }, perkOrBenefit.name);
                                })
                            })
                        ]
                    }, perkName) : null;
                })
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./src/components/JobClientProvidedLocation.tsx



var JobClientProvidedLocation = function(props) {
    var locations = props.locations;
    if (!locations) {
        return null;
    }
    var clientLocations = (0,_to_consumable_array/* default */.Z)(new Set(locations.map(function(x) {
        return x.geocoded_locations;
    }).flat().map(function(x) {
        return x ? x.formatted_address : null;
    }))).filter(function(location) {
        return location;
    }).join("; ");
    if (!clientLocations) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: "Client-provided location(s):"
            }),
            " ",
            clientLocations
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlerts/JobAlerts.tsx + 181 modules
var JobAlerts = __webpack_require__(41);
// EXTERNAL MODULE: ./src/utils/api.ts + 1 modules
var api = __webpack_require__(2394);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(2708);
;// CONCATENATED MODULE: ./src/components/JobAlertsWrapper.tsx










var getCategory = function(job) {
    var ref, ref1, ref2, ref3;
    return {
        value: (ref = job.categories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code,
        label: (ref2 = job.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value
    };
};
var transformJobLocations = function(locations) {
    return locations === null || locations === void 0 ? void 0 : locations.filter(function(x) {
        return x === null || x === void 0 ? void 0 : x.value;
    }).map(function(location) {
        return {
            value: location.value,
            label: location.value
        };
    });
};
var getUserLocation = function(setUserLocation) {
    try {
        setUserLocation(JSON.parse(window.sessionStorage.getItem("user_location")));
    } catch (error) {
        console.error("Error parsing user location:", error);
    }
};
var getApiData = function(values, job, isMultipleLocations, jobLocations, jobCategory) {
    var ref, ref1, ref2;
    return {
        jobId: job.id,
        location: isMultipleLocations ? values === null || values === void 0 ? void 0 : values.location : jobLocations === null || jobLocations === void 0 ? void 0 : (ref = jobLocations[0]) === null || ref === void 0 ? void 0 : ref.value,
        category: jobCategory.value,
        level: (ref1 = job.levels) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value,
        keyword: job.normalizedTitle,
        email: values === null || values === void 0 ? void 0 : values.email,
        newsletter: values === null || values === void 0 ? void 0 : values.newsletter,
        page_section: "job_detail"
    };
};
var getTrackingData = function(values, jobCategory, jobLocations, errorType) {
    return {
        sp_modal_type: "job_alert",
        sp_modal_error_type: errorType,
        sp_modal_action_type: "submit",
        sp_modal_screen_order: null,
        sp_modal_screen_name: null,
        sp_modal_newsletter_opt_in: values === null || values === void 0 ? void 0 : values.newsletter,
        sp_modal_job_category: jobCategory.value,
        sp_modal_job_location: (jobLocations === null || jobLocations === void 0 ? void 0 : jobLocations.length) ? jobLocations === null || jobLocations === void 0 ? void 0 : jobLocations[0].label : values === null || values === void 0 ? void 0 : values.location
    };
};
var JobAlertsWrapper = function(props) {
    var job = props.job, jobAlertViewed = props.jobAlertViewed, setJobAlertViewed = props.setJobAlertViewed, successViewed = props.successViewed, setSuccessViewed = props.setSuccessViewed;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), userLocation = ref[0], setUserLocation = ref[1];
    var jobCategory = react.useMemo(function() {
        return getCategory(job);
    }, [
        job
    ]);
    var jobLocations = react.useMemo(function() {
        return transformJobLocations(job.locations);
    }, [
        job.locations
    ]);
    var isMultipleLocations = !!(jobLocations === null || jobLocations === void 0 ? void 0 : jobLocations.length);
    var jobAlertInViewCallback = function(inView, entry) {
        if (inView && !jobAlertViewed) {
            setJobAlertViewed(true);
            (0,build.triggerSnowplowImpressionEvent)(entry.target);
        }
    };
    var successInViewCallback = function(inView, entry) {
        if (inView && !successViewed) {
            setSuccessViewed(true);
            (0,build.triggerSnowplowImpressionEvent)(entry.target);
        }
    };
    var ref1 = (0,react_intersection_observer/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "0px",
        onChange: successInViewCallback
    }), successRef = ref1.ref;
    var ref2 = (0,react_intersection_observer/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "0px",
        onChange: jobAlertInViewCallback
    }), formRef = ref2.ref;
    react.useEffect(function() {
        getUserLocation(setUserLocation);
    }, []);
    var defaultLocation = react.useMemo(function() {
        if ((userLocation === null || userLocation === void 0 ? void 0 : userLocation.city) && isMultipleLocations) {
            return jobLocations.find(function(location) {
                var ref;
                return location === null || location === void 0 ? void 0 : (ref = location.value) === null || ref === void 0 ? void 0 : ref.includes(userLocation.city);
            });
        }
        return null;
    }, [
        userLocation,
        isMultipleLocations,
        jobLocations
    ]);
    var jobAlertsProps = react.useMemo(function() {
        return {
            handleFormSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                    var apiData, optinSuccess, errorType, trackingData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                apiData = getApiData(values, job, isMultipleLocations, jobLocations, jobCategory);
                                _ctx.next = 3;
                                return (0,api/* jobAlertsSubscribeRequest */.Ml)(apiData);
                            case 3:
                                optinSuccess = _ctx.sent;
                                errorType = optinSuccess ? null : "Job Alerts subscription was unsuccessful.";
                                trackingData = getTrackingData(values, jobCategory, jobLocations, errorType);
                                (0,build.triggerSnowplowModalActionEvent)(trackingData);
                                return _ctx.abrupt("return", optinSuccess);
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            jobCategory: jobCategory.label,
            jobLocations: jobLocations,
            successRef: successRef,
            defaultLocation: defaultLocation,
            formRef: formRef
        };
    }, [
        jobCategory,
        jobLocations,
        successRef,
        defaultLocation,
        formRef,
        job,
        isMultipleLocations
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlerts/* default */.Z, (0,_object_spread/* default */.Z)({}, jobAlertsProps));
};


;// CONCATENATED MODULE: ./src/components/JobIndividualBody.tsx



/* eslint-disable camelcase */ /* eslint-disable react/no-danger */ 









var MemoizedPerksAndBenefits = /*#__PURE__*/ react.memo(PerksAndBenefits);
var JobIndividualBody = function(props) {
    var ref = (0,AppContext/* useAppState */.mr)(), job = ref.job, company = ref.company;
    var has_jwp_company_playlist = company.has_jwp_company_playlist, tmp = company.name, companyName = tmp === void 0 ? "" : tmp;
    var ats_info = job.ats_info, _compiled_contents = job.compiled_contents, compiled_contents = _compiled_contents === void 0 ? [] : _compiled_contents, tmp1 = job.state, jobState = tmp1 === void 0 ? "" : tmp1, jobId = job.id, _locations = job.locations, locations = _locations === void 0 ? [] : _locations, _has_jwp_hiring_manager_playlist = job.has_jwp_hiring_manager_playlist, has_jwp_hiring_manager_playlist = _has_jwp_hiring_manager_playlist === void 0 ? false : _has_jwp_hiring_manager_playlist, employmentTypes = job.employmentTypes;
    var ref1 = ats_info || {}, _directApplyService = ref1.directApplyService, directApplyService = _directApplyService === void 0 ? "" : _directApplyService, tmp2 = ref1.id, atsId = tmp2 === void 0 ? "" : tmp2;
    var setIsOpen = props.setIsOpen, _isFrame = props.isFrame, isFrame = _isFrame === void 0 ? false : _isFrame;
    var ref2 = (0,react.useState)(false), jobAlertsViewed = ref2[0], setJobAlertsViewed = ref2[1];
    var ref3 = (0,react.useState)(false), successViewed = ref3[0], setSuccessViewed = ref3[1];
    var trackApplyProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,tracking/* getJobTrackingProps */.C)(job, company)), {
        placement_position: "desktop_bottom"
    });
    // Converts the values to a more readable format by removing underscores and returning title case.
    var employmentDisplayTypes = employmentTypes.map(function(x) {
        return x.replace("_", " ").toLowerCase().replace(/\b\w/g, function(s) {
            return s.toUpperCase();
        });
    }).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "".concat((JobIndividualBody_module_default()).jobBodyContainer, " ").concat(isFrame ? (JobIndividualBody_module_default()).framed : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (JobIndividualBody_module_default()).jobBodyDescription,
                children: compiled_contents.map(function(x, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: x
                                }
                            }),
                            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsWrapper, {
                                job: job,
                                jobAlertViewed: jobAlertsViewed,
                                setJobAlertViewed: setJobAlertsViewed,
                                successViewed: successViewed,
                                setSuccessViewed: setSuccessViewed
                            })
                        ]
                    }, x.slice(1, 32));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobIndividualBody_module_default()).jobBodyFooter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobClientProvidedLocation, {
                        locations: locations
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Job ID:"
                    }),
                    " ",
                    atsId,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Employment Type:"
                    }),
                    " ",
                    employmentDisplayTypes
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((JobIndividualBody_module_default()).applyContainer, " ").concat(isFrame ? (JobIndividualBody_module_default()).framed : ""),
                children: jobState === "live" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButton/* JobApplyButton */.q, {
                    className: "".concat((JobIndividualBody_module_default()).applyButton, " ").concat(isFrame ? (JobIndividualBody_module_default()).framed : ""),
                    jobId: jobId,
                    setIsOpen: setIsOpen,
                    isDirectApply: !!directApplyService,
                    trackingProps: trackApplyProps
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (JobIndividualBody_module_default()).archivedJobMessage,
                            children: "This job is no longer available."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                            className: "".concat((JobIndividualBody_module_default()).archiveButton, " ").concat(isFrame ? (JobIndividualBody_module_default()).framed : ""),
                            href: "/search",
                            target: "_blank",
                            color: "mint",
                            children: "Search all jobs"
                        })
                    ]
                })
            }),
            has_jwp_hiring_manager_playlist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JWPlayerVideoModule, {
                title: "Meet the Hiring Manager",
                description: "Hear directly from the hiring manager about what it is like to work here.",
                tagName: jobId
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedPerksAndBenefits, {
                company: company
            }),
            has_jwp_company_playlist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JWPlayerVideoModule, {
                title: "Company Videos",
                description: "Hear directly from employees about what it is like to work at ".concat(companyName, "."),
                tagName: "".concat(companyName, ",final"),
                excludeTag: true
            }) : null
        ]
    });
};
JobIndividualBody.displayName = "JobIndividualBody";


/***/ }),

/***/ 9969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Op": function() { return /* binding */ JobIndividualHeader; }
});

// UNUSED EXPORTS: JobHeader, ViewedMsg

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(5151);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(4636);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 5 modules
var AppContext = __webpack_require__(6833);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/CompanyLogoOutlined/CompanyLogoOutlined.tsx
var CompanyLogoOutlined = __webpack_require__(9139);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowRightShape.tsx
var ArrowRightShape = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/icons/IndustryIcon.tsx




/* eslint-disable max-len */ 
var IndustryIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-250.000000, -406.000000)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        transform: "translate(228.000000, 232.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "translate(20.000000, 143.000000)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(0.000000, 29.000000)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "translate(2.000000, 2.000000)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M17.3555556,4.16666667 L3.75555556,4.16666667 C3.30468581,4.16666667 2.87228656,4.36419792 2.55347281,4.71585417 C2.23466331,5.06746354 2.05555556,5.54436979 2.05555556,6.04166667 L2.05555556,17.2916667 C2.05555556,17.7889635 2.23466331,18.2658698 2.55347281,18.6174792 C2.87228656,18.9691354 3.30468581,19.1666667 3.75555556,19.1666667 L17.3555556,19.1666667 C17.8064381,19.1666667 18.2388331,18.9691354 18.5576256,18.6174792 C18.8764606,18.2658698 19.0555556,17.7889635 19.0555556,17.2916667 L19.0555556,6.04166667 C19.0555556,5.54436979 18.8764606,5.06746354 18.5576256,4.71585417 C18.2388331,4.36419792 17.8064381,4.16666667 17.3555556,4.16666667 L17.3555556,4.16666667 Z M13.1055556,9.66510417 C13.1055556,10.0256198 12.9757181,10.3714167 12.7445606,10.6263229 C12.5134456,10.881276 12.1999231,11.0244792 11.8730556,11.0244792 L9.23805556,11.0244792 C8.91118806,11.0244792 8.59766556,10.881276 8.36655056,10.6263229 C8.13539306,10.3714167 8.00555556,10.0256198 8.00555556,9.66510417 L8.00555556,8.63385417 C8.00555556,8.27333854 8.13539306,7.92754167 8.36655056,7.67263542 C8.59766556,7.41768229 8.91118806,7.27447917 9.23805556,7.27447917 L11.8730556,7.27447917 C12.1999231,7.27447917 12.5134456,7.41768229 12.7445606,7.67263542 C12.9757181,7.92754167 13.1055556,8.27333854 13.1055556,8.63385417 L13.1055556,9.66510417 Z",
                                            fill: "#D8D8D8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M16.9397517,4.46987952 L12.9277075,4.46987952 L12.9277075,2.62650602 C12.9254521,2.19583325 12.7533462,1.78344675 12.4487778,1.47890843 C12.1442528,1.17437446 11.7318581,1.00227711 11.3012031,1 L8.69879602,1 C8.26814102,1.00227711 7.85574625,1.17437446 7.55122125,1.47890843 C7.24665288,1.78344675 7.0745904,2.19583325 7.07229161,2.62650602 L7.07229161,4.46554217 L3.06024741,4.46554217 C2.78932816,4.46554217 2.52106771,4.51897831 2.27082458,4.62277108 C2.02058146,4.72660723 1.79326988,4.87871807 1.60190621,5.07051566 C1.41053821,5.26226988 1.25886993,5.48989398 1.15558906,5.7403759 C1.0523082,5.99081446 0.999440304,6.25920964 1.00000396,6.53012048 L1.00000396,16.939759 C1.00000396,17.4861783 1.21707093,18.0102169 1.60344163,18.396588 C1.98980799,18.782959 2.51383735,19 3.06024741,19 L16.9397517,19 C17.4861704,19 18.0102084,18.782959 18.3965791,18.396588 C18.7829498,18.0102169 18.9999906,17.4861783 18.9999906,16.939759 L18.9999906,6.53012048 C18.9999906,5.9837012 18.7829498,5.45966265 18.3965791,5.07329157 C18.0102084,4.68692048 17.4861704,4.46987952 16.9397517,4.46987952 L16.9397517,4.46987952 Z M7.72289337,2.62650602 C7.72402108,2.36803036 7.82720652,2.12046747 8.00998224,1.93770024 C8.19275797,1.75492867 8.44033362,1.65174313 8.69879602,1.65060241 L11.3012031,1.65060241 C11.5596655,1.65174313 11.8072411,1.75492867 11.9900168,1.93770024 C12.1727926,2.12046747 12.275978,2.36803036 12.2771057,2.62650602 L12.2771057,4.46554217 L7.72289337,4.46554217 L7.72289337,2.62650602 Z M3.06024741,5.12048193 L16.9397517,5.12048193 C17.3132405,5.12160964 17.6711582,5.27051084 17.9352591,5.53461205 C18.1993601,5.79871325 18.3482611,6.15663133 18.3493888,6.53012048 L18.3493888,9.21060241 L12.9277075,9.21060241 L12.9277075,8.9286747 C12.9265798,8.50916627 12.7594185,8.10713735 12.4627441,7.81050602 C12.166113,7.51383133 11.7640845,7.34666988 11.3445765,7.34554217 L8.65542256,7.34554217 C8.23591455,7.34666988 7.83388603,7.51383133 7.537255,7.81050602 C7.2405806,8.10713735 7.07341932,8.50916627 7.07229161,8.9286747 L7.07229161,9.21060241 L1.65061026,9.21060241 L1.65061026,6.53012048 C1.65175532,6.15663133 1.80063902,5.79871325 2.06474864,5.53461205 C2.32885826,5.27051084 2.68674128,5.12160964 3.06024741,5.12048193 L3.06024741,5.12048193 Z M12.2771057,8.9286747 L12.2771057,9.88289157 C12.275978,10.1298602 12.1773468,10.3663759 12.0027253,10.541041 C11.8280604,10.7156627 11.5915449,10.814294 11.3445765,10.8154217 L8.65542256,10.8154217 C8.40845414,10.814294 8.17193871,10.7156627 7.99727382,10.541041 C7.82265231,10.3663759 7.72402108,10.1298602 7.72289337,9.88289157 L7.72289337,8.9286747 C7.72289337,8.68135904 7.82113424,8.4441494 7.99601599,8.26926747 C8.17089775,8.09438554 8.40810715,7.99614458 8.65542256,7.99614458 L11.3445765,7.99614458 C11.5918919,7.99614458 11.8291013,8.09438554 12.0039831,8.26926747 C12.1788648,8.4441494 12.2771057,8.68135904 12.2771057,8.9286747 L12.2771057,8.9286747 Z M16.9397517,18.3493976 L3.06024741,18.3493976 C2.68674128,18.3482699 2.32885826,18.1993687 2.06474864,17.9352675 C1.80063902,17.6711663 1.65175532,17.3132482 1.65061026,16.939759 L1.65061026,9.86120482 L7.07229161,9.86120482 L7.07229161,9.88289157 C7.07341932,10.3024 7.2405806,10.7044289 7.537255,11.0010602 C7.83388603,11.2977349 8.23591455,11.4648964 8.65542256,11.4660241 L11.3445765,11.4660241 C11.7640845,11.4648964 12.166113,11.2977349 12.4627441,11.0010602 C12.7594185,10.7044289 12.9265798,10.3024 12.9277075,9.88289157 L12.9277075,9.86120482 L18.3493888,9.86120482 L18.3493888,16.939759 C18.3482611,17.3132482 18.1993601,17.6711663 17.9352591,17.9352675 C17.6711582,18.1993687 17.3132405,18.3482699 16.9397517,18.3493976 L16.9397517,18.3493976 Z",
                                            fill: "#666666"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/SizeIcon.tsx




/* eslint-disable max-len */ 
var SizeIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-250.000000, -377.000000)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        transform: "translate(228.000000, 232.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "translate(20.000000, 143.000000)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                transform: "translate(2.000000, 2.000000)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M14.1298213,7.81811542 C14.9860301,7.329114 15.6416275,6.54476184 15.9779398,5.60709493 C16.3142521,4.66942802 16.308984,3.64043177 15.9631703,2.70633488 C15.6173565,1.7722571 14.95381,0.994849024 14.0926623,0.51485628 C13.2314675,0.0348635361 12.2296331,-0.115989961 11.2684854,0.0896037849 C10.3073377,0.29520231 9.45037629,0.843656208 8.8528222,1.63567888 C8.25522107,2.42770634 7.95649106,3.41093756 8.01067733,4.40743566 C8.06486359,5.40388597 8.46839135,6.34771797 9.14821261,7.06802968 C9.82803387,7.7882936 10.7392286,8.23753259 11.7168391,8.33426234 L12.5258702,8.33426234 C13.4159454,8.33550492 14.2970837,8.51491377 15.1189558,8.86216595 C15.9408278,9.20941813 16.6873471,9.71772727 17.3158984,10.358084 C17.9444026,10.9984885 18.4426152,11.7583715 18.7821261,12.5943861 C19.1215898,13.4304008 19.2956726,14.3262024 19.2944497,15.2305588 C19.2944497,15.2445138 19.2889934,15.2578954 19.2793039,15.2677404 C19.2696143,15.2775855 19.256444,15.2831293 19.2427093,15.2831293 L5,15.2831293 L5,16 L19.2427093,16 C19.443556,16 19.6361712,15.9189458 19.778175,15.7746636 C19.9202258,15.6303337 20,15.434628 20,15.2305588 C19.9972248,13.5008931 19.414111,11.8238457 18.3468956,10.4762243 C17.2796802,9.12865069 15.7921449,8.19103157 14.1298213,7.81811542 L14.1298213,7.81811542 Z M8.71119473,4.17163298 C8.71119473,3.48635236 8.91119473,2.816451 9.28588899,2.24665347 C9.66063029,1.67686072 10.1932267,1.2327593 10.8163217,0.970508873 C11.4394638,0.708263223 12.1251176,0.639644357 12.7866416,0.773335969 C13.4481656,0.90703236 14.0557855,1.23702707 14.5326905,1.72159823 C15.0096425,2.20616939 15.3344309,2.8235528 15.4659925,3.49567168 C15.5975541,4.16780967 15.5300564,4.86446465 15.2719191,5.49760487 C15.0138288,6.13069731 14.5767168,6.67183913 14.0159454,7.05259307 C13.455127,7.43329921 12.7958137,7.63650817 12.1213547,7.63650817 C11.2173095,7.63526559 10.3506585,7.2698049 9.71138288,6.62027222 C9.07210724,5.97073955 8.71241769,5.09018334 8.71119473,4.17163298 L8.71119473,4.17163298 Z",
                                        fill: "#666666"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7.57,12 L8.43,12 C10.4377,12 12.36315,12.6978562 13.7828,13.94005 C15.20245,15.1822437 16,16.8670125 16,18.62375 C16,18.7235437 15.9547,18.819225 15.87405,18.8897938 C15.7934,18.9603625 15.68405,19 15.57,19 L0.43,19 C0.315955,19 0.206585,18.9603625 0.125945,18.8897938 C0.045305,18.819225 0,18.7235437 0,18.62375 C0,16.8670125 0.79755,15.1822437 2.2172,13.94005 C3.63685,12.6978562 5.5623,12 7.57,12 L7.57,12 Z",
                                        fill: "#D8D8D8"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8,12 C10.20915,12 12,10.20915 12,8 C12,5.79085 10.20915,4 8,4 C5.79085,4 4,5.79085 4,8 C4,10.20915 5.79085,12 8,12 Z",
                                        fill: "#D8D8D8"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M10.039403,11.8250894 C10.8467104,11.3738458 11.4814567,10.667566 11.8442507,9.81698371 C12.206997,8.96640145 12.2773015,8.01950614 12.0440836,7.12465903 C11.8108657,6.22985967 11.2873075,5.43767645 10.5555104,4.8722133 C9.82366567,4.30675015 8.92489552,4 8,4 C7.07510448,4 6.17633433,4.30675015 5.44448955,4.8722133 C4.71269254,5.43767645 4.18913433,6.22985967 3.95591642,7.12465903 C3.72269851,8.01950614 3.79300299,8.96640145 4.15574925,9.81698371 C4.51854328,10.667566 5.15328955,11.3738458 5.96059701,11.8250894 C4.27266866,12.1976877 2.76220657,13.1345076 1.67855284,14.4809326 C0.594903881,15.8274053 0.00281313433,17.5030232 0,19.2312146 C0,19.4351099 0.0810125373,19.6306488 0.225222687,19.774808 C0.296625672,19.8461952 0.381397015,19.9028274 0.474688955,19.9414577 C0.567980896,19.9801357 0.667973731,20 0.768955224,20 L15.2310448,20 C15.4349851,20 15.6305672,19.9190149 15.7747582,19.774808 C15.918997,19.6306488 16,19.4351099 16,19.2312146 C15.9971821,17.5030232 15.4050866,15.8274053 14.3214328,14.4809326 C13.2377791,13.1345076 11.7273313,12.1976877 10.039403,11.8250894 L10.039403,11.8250894 Z M4.53731343,8.18171508 C4.53731343,7.49701857 4.74039403,6.82769776 5.1208597,6.25836681 C5.50137313,5.68908361 6.04217313,5.24533685 6.67486567,4.98332906 C7.30760597,4.72127351 8.0038209,4.65275133 8.67553433,4.78630989 C9.34724776,4.91986845 9.96422687,5.24958666 10.4484776,5.73377821 C10.9327761,6.21792201 11.2625672,6.83476486 11.3961552,7.50632995 C11.5297433,8.17789503 11.461206,8.8739562 11.1990925,9.50655676 C10.9370269,10.1391096 10.4931821,10.6797901 9.92377313,11.0602195 C9.35431642,11.4406012 8.68484776,11.6436369 8,11.6436369 C7.08202985,11.6423954 6.20202985,11.2772462 5.55290746,10.6282672 C4.90378507,9.97928816 4.53855522,9.0994825 4.53731343,8.18171508 L4.53731343,8.18171508 Z M15.2310448,19.2837403 L0.768955224,19.2837403 C0.755023284,19.2837403 0.741659701,19.2782012 0.731806567,19.2683646 C0.721953433,19.2584802 0.71641791,19.2451578 0.71641791,19.2312146 C0.718944478,17.4096229 1.44385433,15.6633341 2.73221731,14.3752604 C4.02058507,13.0871867 5.7672597,12.3624274 7.58925373,12.3598966 L8.41074627,12.3598966 C10.2327403,12.3624274 11.9794149,13.0871867 13.2677731,14.3752604 C14.5561313,15.6633341 15.2810507,17.4096229 15.2835821,19.2312146 C15.2835821,19.2451578 15.2780418,19.2584802 15.268203,19.2683646 C15.2583642,19.2782012 15.244991,19.2837403 15.2310448,19.2837403 Z",
                                        fill: "#666666"
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    }));
};


// EXTERNAL MODULE: ./src/components/CompanyInformationModule.module.scss
var CompanyInformationModule_module = __webpack_require__(7985);
var CompanyInformationModule_module_default = /*#__PURE__*/__webpack_require__.n(CompanyInformationModule_module);
;// CONCATENATED MODULE: ./src/components/CompanyInformationModule.tsx

/* eslint-disable react/jsx-no-target-blank */ 






var getPilboxUrl = function(imageUrl, imageWidth) {
    var pilboxUrl = "https://pilbox.themuse.com/";
    var imageUrlRegex = /^https?:\/\//;
    if (imageUrlRegex.test(imageUrl)) {
        return "".concat(pilboxUrl, "?url=").concat(imageUrl, "&w=").concat(imageWidth, "&filter=antialias&opt=1&pos=center&prog=1&q=keep");
    }
    return "";
};
var CompanyInformation = function(props) {
    var ref, ref1;
    var company = props.company, _displayOnMobile = props.displayOnMobile, displayOnMobile = _displayOnMobile === void 0 ? false : _displayOnMobile;
    var companySize = (0,strings/* formatCompanySize */.YS)(company === null || company === void 0 ? void 0 : company.employee_range);
    var companyIndustries = (0,strings/* getCompanyIndustries */.kr)(company === null || company === void 0 ? void 0 : company.industries);
    var companyLogo = (0,strings/* getCompanyLogo */.GW)(company === null || company === void 0 ? void 0 : company.logo) || "";
    var snapshotPhotoSrc = getPilboxUrl(company === null || company === void 0 ? void 0 : company.snapshot_photo, 500);
    var display = displayOnMobile ? "mobile" : "desktop";
    var containerClasses = classnames_default()(snapshotPhotoSrc ? "".concat((CompanyInformationModule_module_default()).companyInformationModule, " ").concat((CompanyInformationModule_module_default()).hasPhoto, " ").concat((CompanyInformationModule_module_default())[display]) : "".concat((CompanyInformationModule_module_default()).companyInformationModule, " ").concat((CompanyInformationModule_module_default())[display]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: containerClasses,
        children: [
            companyLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoOutlined/* default */.Z, {
                className: (CompanyInformationModule_module_default()).companyLogo,
                logoUrl: companyLogo,
                altText: "".concat(company === null || company === void 0 ? void 0 : company.name, " Logo")
            }) : null,
            (company === null || company === void 0 ? void 0 : (ref = company.short_description) === null || ref === void 0 ? void 0 : ref.length) > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "About Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (CompanyInformationModule_module_default()).companyShortDescription,
                        children: company.short_description
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    (company === null || company === void 0 ? void 0 : company.employee_range) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Size:"
                            }),
                            " ",
                            "".concat(companySize, " employees")
                        ]
                    }) : null,
                    (company === null || company === void 0 ? void 0 : (ref1 = company.industries) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Industry:"
                            }),
                            " ",
                            companyIndustries
                        ]
                    }) : null
                ]
            }),
            snapshotPhotoSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: company === null || company === void 0 ? void 0 : company.name,
                loading: displayOnMobile ? "lazy" : "eager",
                src: snapshotPhotoSrc,
                height: "167",
                width: "250"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (CompanyInformationModule_module_default()).companyProfileLink,
                href: "/profiles/".concat(company === null || company === void 0 ? void 0 : company.short_name),
                target: "_blank",
                children: [
                    "View Company Profile",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {})
                ]
            })
        ]
    });
};
CompanyInformation.displayName = "CompanyInformationModule";
var CompanyInformationModule = /*#__PURE__*/ react.memo(CompanyInformation);

// EXTERNAL MODULE: ./src/utils/interactionHistory.ts
var interactionHistory = __webpack_require__(2184);
;// CONCATENATED MODULE: ./src/utils/dates.ts
var day = 1000 * 60 * 60 * 24;
var mn = "month";
var wk = "week";
var dy = "day";
/**
 * Calculate date difference in whole days.
 */ var daysMath = function(ms) {
    var now = new Date();
    return Math.abs(Math.ceil((ms - now.getTime()) / day));
};
var getTimeAgoString = function(num, span) {
    return "".concat(num).concat(num > 2 && span === mn ? "+" : "", " ").concat(span).concat(num > 1 ? "s" : "", " ago");
};
/**
 * Format a date in days, weeks months ago.
 */ var formatDateAsAge = function(posted) {
    var now = new Date();
    var midnightMs = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
    var postedDate = new Date(posted);
    var postedMs = new Date(postedDate.getFullYear(), postedDate.getMonth(), postedDate.getDate(), 0, 0, 0).getTime();
    switch(true){
        case postedMs < midnightMs - day * 90:
            return getTimeAgoString(3, mn);
        case postedMs < midnightMs - day * 60:
            return getTimeAgoString(2, mn);
        case postedMs < midnightMs - day * 28:
            return getTimeAgoString(1, mn);
        case postedMs < midnightMs - day * 21:
            return getTimeAgoString(3, wk);
        case postedMs < midnightMs - day * 14:
            return getTimeAgoString(2, wk);
        case postedMs < midnightMs - day * 7:
            return getTimeAgoString(1, wk);
        case postedMs < midnightMs - day:
            return getTimeAgoString(daysMath(postedMs), dy);
        case postedMs < midnightMs:
            return "Yesterday";
        default:
            return "Today";
    }
};


// EXTERNAL MODULE: ./src/components/JobApplyButton.tsx + 2 modules
var JobApplyButton = __webpack_require__(5550);
// EXTERNAL MODULE: ./src/components/JobIndividualHeader.module.scss
var JobIndividualHeader_module = __webpack_require__(5870);
var JobIndividualHeader_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualHeader_module);
;// CONCATENATED MODULE: ./src/components/JobIndividualHeader.tsx



/* eslint-disable react/jsx-no-target-blank */ 










/**
 * Renders a message indicating when a job was last viewed, but only if it has not been applied to.
 */ var ViewedMsg = function(props) {
    var interactionDate = props.interactionDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (JobIndividualHeader_module_default()).jobInteractionHistoryViewed,
        children: [
            "Viewed on ",
            (0,interactionHistory/* getInteractionDate */.V0)(interactionDate)
        ]
    });
};
var ForwardIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#0A66C2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M8.068 1h-7v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5m-11 2 11-11m0 0h-5m5 0v5"
        })
    });
};
/**
 * Closes the SideBySide modal by sending a message to the top window.
 */ var closeSideBySide = function() {
    window.top.postMessage("closeSideBySide", "*");
};
/**
 * Renders the header component for an individual job.
 *
 * This component displays the company name, job title, posted date, location, and company information.
 * It also tracks user interactions and applies appropriate styling based on the user's actions.
 *
 * @returns {ReactElement} The rendered header component for an individual job.
 */ var JobHeader = function(props) {
    var setIsOpen = props.setIsOpen, innerRef = props.innerRef, isFrame = props.isFrame;
    var ref = (0,AppContext/* useAppState */.mr)(), job = ref.job, company = ref.company;
    var ref1 = (0,react.useState)(null), interactionDate = ref1[0], setInteractionDate = ref1[1];
    var ref2 = (0,react.useState)(false), showViewedMsg = ref2[0], setShowViewedMsg = ref2[1];
    var ref3 = (0,react.useState)(""), formattedDate = ref3[0], setFormattedDate = ref3[1];
    var jobName = job.name, postedDate = job.posted_at, _locations = job.locations, locations = _locations === void 0 ? [] : _locations, id = job.id, state = job.state, ats_info = job.ats_info, jobShortName = job.short_name;
    var companyShortName = company.short_name, pkg = company["package"], companyName = company.name;
    var ref4 = ats_info || {}, _directApplyService = ref4.directApplyService, directApplyService = _directApplyService === void 0 ? "" : _directApplyService;
    var ref5 = (0,strings/* getLocations */.JC)(locations), dispLocation = ref5.dispLocation, tooltipProps = ref5.tooltipProps;
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.C)(job, company);
    // check previous interactions with this page only once.
    (0,react.useEffect)(function() {
        // always manipulate dates on the client.
        setFormattedDate(formatDateAsAge(postedDate));
        var lastInteraction = (0,interactionHistory/* getJobLastInteraction */.xy)(id);
        if (lastInteraction) {
            setInteractionDate(lastInteraction === null || lastInteraction === void 0 ? void 0 : lastInteraction.dt);
            setShowViewedMsg(!isFrame && !(lastInteraction === null || lastInteraction === void 0 ? void 0 : lastInteraction.app));
        }
    }, [
        id,
        isFrame,
        postedDate
    ]);
    // get live interactions as they change.
    (0,react.useEffect)(function() {
        var checkApplyStatus = function() {
            var interaction = (0,interactionHistory/* getJobLastInteraction */.xy)(id);
            if (interaction === null || interaction === void 0 ? void 0 : interaction.app) {
                setShowViewedMsg(false);
            }
        };
        window.addEventListener("storage", checkApplyStatus);
        return function() {
            window.removeEventListener("storage", checkApplyStatus);
        };
    }, [
        id
    ]);
    var trackJobApplyProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jobTrackingProps), {
        placement_position: "main",
        sp_click_position: "main"
    });
    var redirectUrl = "/jobs/".concat(companyShortName, "/").concat(jobShortName);
    // used to test if the parent page is mobile as the Iframe has no idea.
    var ref6 = (0,react.useState)(false), isMobile = ref6[0], setIsMobile = ref6[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setIsMobile(!window.parent.matchMedia("(min-width: 992px)").matches);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                ref: innerRef,
                className: (JobIndividualHeader_module_default()).jobHeaderContainer,
                children: [
                    pkg !== "Programmatic" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/profiles/".concat(company.short_name),
                        className: (JobIndividualHeader_module_default()).jobHeaderCompanyName,
                        target: "_blank",
                        children: companyName
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (JobIndividualHeader_module_default()).jobHeaderCompanyNameProgrammatic,
                        children: companyName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (JobIndividualHeader_module_default()).jobHeaderTitle,
                        children: [
                            jobName,
                            isFrame ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: redirectUrl,
                                target: "_blank",
                                className: (JobIndividualHeader_module_default()).newWindow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardIcon, {})
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobIndividualHeader_module_default()).jobHeaderSubHeading,
                        children: [
                            formattedDate,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (JobIndividualHeader_module_default()).jobHeaderSeparator,
                                children: "\u2022"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (JobIndividualHeader_module_default()).jobHeaderLocation,
                                children: dispLocation
                            }),
                            locations.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread/* default */.Z)({}, tooltipProps)) : null,
                            showViewedMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewedMsg, {
                                interactionDate: interactionDate
                            }),
                            state === "live" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButton/* JobApplyButton */.q, {
                                className: "".concat((JobIndividualHeader_module_default()).applyButton, " ").concat(isFrame ? (JobIndividualHeader_module_default()).framed : ""),
                                jobId: id,
                                trackingProps: trackJobApplyProps,
                                setIsOpen: setIsOpen,
                                isDirectApply: !!directApplyService
                            }) : null,
                            state !== "live" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (JobIndividualHeader_module_default()).archived,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (JobIndividualHeader_module_default()).archivedJobMessage,
                                        children: "This job is no longer available."
                                    }),
                                    !isFrame ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                        className: "".concat((JobIndividualHeader_module_default()).archivedButton, " ").concat((JobIndividualHeader_module_default()).isFrame),
                                        href: "/search",
                                        target: "_blank",
                                        color: "mint",
                                        children: "Search all jobs"
                                    }) : null
                                ]
                            }) : null
                        ]
                    }),
                    isFrame && isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (JobIndividualHeader_module_default()).closeIframe,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                            onClick: closeSideBySide
                        })
                    }) : null
                ]
            }),
            pkg !== "Programmatic" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInformationModule, {
                company: company,
                displayOnMobile: false
            }) : null
        ]
    });
};
JobHeader.displayName = "JobIndividualHeader";
var JobIndividualHeader = /*#__PURE__*/ react.memo(JobHeader);


/***/ }),

/***/ 6472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ StickyHeader; }
/* harmony export */ });
/* unused harmony export FloatingHeader */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5151);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1410);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/* harmony import */ var _JobApplyButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5550);
/* harmony import */ var utils_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1771);
/* harmony import */ var _StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7423);
/* harmony import */ var _StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7__);



/* eslint-disable react/jsx-no-target-blank */ 





/**
 * Closes the SideBySide modal by sending a message to the top window.
 */ var closeSideBySide = function() {
    window.top.postMessage("closeSideBySide", "*");
};
/**
 * Renders the sticky header component for an individual job.
 *
 * This component displays the company name, job title, posted date, location, and company information.
 * It also tracks user interactions and applies appropriate styling based on the user's actions.
 *
 * @returns {ReactElement} The rendered header component for an individual job.
 */ var StickyHeader = function(props) {
    var ref = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__/* .useAppState */ .mr)(), job = ref.job, company = ref.company;
    var id = job.id, jobName = job.name, state = job.state, ats_info = job.ats_info;
    var pkg = company["package"], companyName = company.name;
    var _directApplyService = ats_info.directApplyService, directApplyService = _directApplyService === void 0 ? "" : _directApplyService;
    var jobTrackingProps = (0,utils_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getJobTrackingProps */ .C)(job, company);
    var setIsOpen = props.setIsOpen, isSticky = props.isSticky, isFrame = props.isFrame;
    var applyText = directApplyService ? "Quick Apply" : "Apply on company site";
    var buttonText = state === "live" ? applyText : "Search all jobs";
    var liveTargetSection = directApplyService ? "direct_apply_form" : "off_site";
    var targetSection = state === "live" ? liveTargetSection : "search";
    var trackingObj = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, jobTrackingProps), {
        sp_click_button_text: buttonText,
        sp_click_target_page_section: targetSection,
        sp_click_position: "sticky_nav",
        target_page_section: "direct_apply_form",
        sp_click_button_type: state === "live" ? "apply" : "job_search"
    });
    // used to test if the parent page is mobile as the Iframe has no idea.
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMobile = ref1[0], setIsMobile = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleResize = function() {
            setIsMobile(!window.parent.matchMedia("(min-width: 992px)").matches);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var impressionTrackingObj = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, jobTrackingProps), {
        target_page_section: "direct_apply_form",
        sp_impression_component: "insert",
        sp_impression_tile_type: null,
        sp_impression_card_type: null,
        sp_impression_insert_type: "jobs_cta",
        sp_impression_modal_type: null,
        sp_impression_position: "pop_up",
        sp_impression_search_id: null,
        sp_impression_button_type: null
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().stickyHeader), " ").concat(isSticky ? (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open) : "", " ").concat(isFrame ? (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().framed) : ""),
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify(impressionTrackingObj),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
            children: [
                isFrame && isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().closeIframe),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onClick: closeSideBySide
                    })
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().names),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                            children: jobName
                        }),
                        pkg !== "Programmatic" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "/profiles/".concat(company.short_name),
                            className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().companyName),
                            target: "_blank",
                            children: [
                                "AT ",
                                companyName
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().companyNameProgrammatic),
                            children: companyName
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().actions),
                    children: [
                        state === "live" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JobApplyButton__WEBPACK_IMPORTED_MODULE_3__/* .JobApplyButton */ .q, {
                            jobId: id,
                            className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().applyButton),
                            trackingProps: trackingObj,
                            setIsOpen: setIsOpen,
                            isDirectApply: !!directApplyService
                        }) : null,
                        state !== "live" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().archivedJobMessage),
                                    children: "This job is no longer available."
                                }),
                                !isFrame ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    className: (_StickyHeader_module_scss__WEBPACK_IMPORTED_MODULE_7___default().archiveButton),
                                    "data-tracking-event-type": "click",
                                    "data-tracking-props": trackingObj,
                                    href: "/search",
                                    target: "_blank",
                                    color: "mint",
                                    children: buttonText
                                }) : null
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
StickyHeader.displayName = "StickyHeader";
var FloatingHeader = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(StickyHeader)));


/***/ }),

/***/ 2262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ UserInit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(253);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5666);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6833);
/* harmony import */ var interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4182);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2394);
/* harmony import */ var utils_logging__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9430);
/* harmony import */ var utils_location__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4345);
/* harmony import */ var mocks_mockUser_json__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3865);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5310);














var setUserCarmenData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(setUserLocation) {
        var carmenResponse, ref, msg, err;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,utils_location__WEBPACK_IMPORTED_MODULE_7__/* .getCarmenData */ .F)();
                case 3:
                    carmenResponse = _ctx.sent;
                    if (carmenResponse) {
                        setUserLocation(JSON.stringify(carmenResponse));
                    }
                    _ctx.next = 13;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    msg = "Error requesting the location from Carmen at ".concat(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.request) === null || ref === void 0 ? void 0 : ref.path, ".");
                    err = JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_6__/* .formatLog */ .Uo)({
                        error: _ctx.t0
                    }));
                    console.warn(msg, err);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function setUserCarmenData(setUserLocation) {
        return _ref.apply(this, arguments);
    };
}();
var UserInit = function(props) {
    var children = props.children;
    var user = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppState */ .mr)().user;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_themuse_design_system__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("user_location"), 2), userLocation = ref[0], setUserLocation = ref[1];
    var appDispatch = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var setUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var apiUser, ref, msg, err;
                return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            if ([
                                "www.themuse.com",
                                "www.staging-themuse.com"
                            ].includes(window.location.host)) {
                                _ctx.next = 6;
                                break;
                            }
                            {
                                apiUser = mocks_mockUser_json__WEBPACK_IMPORTED_MODULE_8__;
                            }
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.next = 8;
                            return (0,utils_api__WEBPACK_IMPORTED_MODULE_5__/* .getUser */ .PR)();
                        case 8:
                            apiUser = _ctx.sent;
                        case 9:
                            if (apiUser === null || apiUser === void 0 ? void 0 : apiUser.logged_in) {
                                appDispatch({
                                    type: interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_4__/* .UserActionTypes.updateUser */ .F6.updateUser,
                                    payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, apiUser), {
                                        location: userLocation ? JSON.parse(userLocation) : null
                                    })
                                });
                            } else {
                                appDispatch({
                                    type: interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_4__/* .UserActionTypes.resetUser */ .F6.resetUser
                                });
                            }
                            _ctx.next = 18;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            msg = "Error requesting the user at ".concat(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.request) === null || ref === void 0 ? void 0 : ref.path, ".");
                            err = JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_6__/* .formatLog */ .Uo)({
                                error: _ctx.t0
                            }));
                            console.warn(msg, err);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function setUser() {
                return _ref.apply(this, arguments);
            };
        }();
        setUser().then(function() {
            setUserCarmenData(setUserLocation);
        })["catch"](function(error) {
            var ref;
            var msg = "Error setting the user at ".concat(error === null || error === void 0 ? void 0 : (ref = error.request) === null || ref === void 0 ? void 0 : ref.path, ".");
            var err = JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_6__/* .formatLog */ .Uo)({
                error: error
            }));
            console.error(msg, err);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        appDispatch({
            type: interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_4__/* .UserActionTypes.updateUser */ .F6.updateUser,
            payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, user), {
                location: userLocation ? JSON.parse(userLocation) : null
            })
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userLocation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
UserInit.displayName = "UserInit";



/***/ }),

/***/ 65:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagsProvider; }
});

// UNUSED EXPORTS: useFeatureFlagsState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts





/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ var isFeatureFlagActive = function(name, query, config) {
    if (name in query) {
        return isTruthy(query[name]);
    }
    if ((config === null || config === void 0 ? void 0 : config[name]) !== undefined) {
        return (config === null || config === void 0 ? void 0 : config[name]) === true || (config === null || config === void 0 ? void 0 : config[name]) === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ var getFeatureFlags = function() {
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    return Object.keys(publicRuntimeConfig).reduce(function(prev, curr) {
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ var getActiveFeatureFlags = function(context) {
    var query = context.query;
    var publicRuntimeConfig = getConfig().publicRuntimeConfig;
    var featureFlagsInQuery = getFeatureFlags().reduce(function(featureFlags, featureFlag) {
        return _object_spread_props(_object_spread({}, featureFlags), _define_property({}, featureFlag, isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)));
    }, {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx






var defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce(function(featureFlags, featureFlag) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, featureFlags), (0,src_define_property/* default */.Z)({}, featureFlag, false));
}, {});
var FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
var FeatureFlagsProvider = function(props) {
    var featureFlags = props.featureFlags, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
var useFeatureFlagsState = function() {
    var context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";



/***/ }),

/***/ 2509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ applyButtonTextConfig; },
/* harmony export */   "p": function() { return /* binding */ getApplyButtonText; }
/* harmony export */ });
var onSite = {
    control_A: "Apply on company site",
    apply_now: "Apply now",
    start_application: "Start application",
    "continue": "Continue",
    apply_directly_to_company: "Apply directly to company"
};
var direct = {
    control_B: "Quick Apply",
    easy_apply: "Easy Apply",
    quick_apply_sparkle: "Quick Apply\u2728",
    apply_directly: "Apply Directly",
    fast_apply: "Fast Apply"
};
var getApplyButtonText = function(state, directApplyService, experiments, getActiveVariant) {
    var experimentId = directApplyService ? "DIRECT_APPLY_CTA_COPY" : "APPLY_CTA_COPY";
    var ref;
    var enabledVariant = (ref = getActiveVariant(experimentId, experiments)) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var applyBtnText = directApplyService ? direct === null || direct === void 0 ? void 0 : direct[enabledVariant] : (ref1 = onSite === null || onSite === void 0 ? void 0 : onSite[enabledVariant]) !== null && ref1 !== void 0 ? ref1 : "";
    var applyTextFallBack = directApplyService ? "Quick Apply" : "Apply on company site";
    var buttonText = state === "live" ? applyBtnText || applyTextFallBack : "Search all jobs";
    return buttonText;
};
var applyButtonTextConfig = [
    {
        name: "APPLY_CTA_COPY",
        variants: Object.keys(onSite).map(function(x) {
            return {
                name: x,
                weight: 20
            };
        })
    },
    {
        name: "DIRECT_APPLY_CTA_COPY",
        variants: Object.keys(direct).map(function(x) {
            return {
                name: x,
                weight: 20
            };
        })
    }
];


/***/ }),

/***/ 2184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QP": function() { return /* binding */ setInteractionViewed; },
/* harmony export */   "V0": function() { return /* binding */ getInteractionDate; },
/* harmony export */   "h$": function() { return /* binding */ getApplicant; },
/* harmony export */   "xy": function() { return /* binding */ getJobLastInteraction; }
/* harmony export */ });
/* unused harmony export getInteractionHistory */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9815);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5023);
/* harmony import */ var _themuse_design_system_lib_constants_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7225);



/**
 * Retrieves the entire interaction history from local storage.
 *
 * @returns {InteractionType[]} - The interaction history array.
 */ var getInteractionHistory = function() {
    try {
        var history = localStorage.getItem("jobInteractionHistory");
        if (!history) return [];
        var result = JSON.parse(history);
        if (Array.isArray(result)) return result;
        // we are malformed so kill this history
        window.localStorage.removeItem("jobInteractionHistory");
        return [];
    } catch (error) {
        var msg = "Job-Renderer was unable to parse the interactions from local storage.";
        console.error(msg, JSON.stringify((0,_themuse_design_system__WEBPACK_IMPORTED_MODULE_0__/* .formatLog */ .U)({
            error: error
        })));
        return [];
    }
};
var ref;
/**
 * Retrieves the most recent interaction for a specific job ID.
 *
 * @param {number} id - The Job ID of the event to retrieve.
 * @returns {InteractionType | null} - The event object if found, otherwise null.
 */ var getJobLastInteraction = function(id) {
    return (ref = getInteractionHistory().find(function(x) {
        return x.id === id;
    })) !== null && ref !== void 0 ? ref : null;
};
/**
 * Sets the interaction as viewed for a specific job ID if that job has not been applied to.
 *
 * @param {number} id - The Job ID of the interaction to set as viewed.
 * @returns {void}
 */ var setInteractionViewed = function(id) {
    var history = getInteractionHistory();
    var jobHistory = getJobLastInteraction(id);
    var viewedEvent = {
        id: id,
        dt: new Date().getTime(),
        app: false
    };
    var payload = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(history.filter(function(x) {
        return x.id !== id;
    })).concat([
        viewedEvent
    ]);
    if (!(jobHistory === null || jobHistory === void 0 ? void 0 : jobHistory.app)) {
        window.localStorage.setItem("jobInteractionHistory", JSON.stringify(payload));
        window.dispatchEvent(new Event("storage"));
        return viewedEvent;
    }
    return jobHistory;
};
var getApplicant = function() {
    if (!_themuse_design_system_lib_constants_browser__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .j) return false;
    return !!localStorage.getItem("Applicant");
};
/**
 * Returns a formatted date string in the "month day, year" format.
 *
 * @param dt - A timestamp representing a date and time.
 * @returns A formatted date string representing the input timestamp in the "month day, year" format.
 *
 * @example
 * const dt = 1627896000000;
 * const date = getInteractionDate(dt);
 * console.log(date); // Output: "August 3, 2021"
 */ var getInteractionDate = function(dt) {
    return new Date(dt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};


/***/ }),

/***/ 4345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ locationIsRemote; },
/* harmony export */   "F": function() { return /* binding */ getCarmenData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5666);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1752);
/* harmony import */ var utils_jobRendererAxiosClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6750);




/**
 * Get data from Carmen using requesters ip address by default
 * @param ip optional IP address to lookup
 */ var getCarmenData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ip) {
        var ref, _publicRuntimeConfig, apiRequestTimeoutMs, carmenApiHost, suffix, carmenUrl, response;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, carmenApiHost = _publicRuntimeConfig.carmenApiHost;
                    suffix = ip ? "/ip/".concat(ip) : "/me";
                    carmenUrl = "".concat(carmenApiHost).concat(suffix);
                    _ctx.next = 5;
                    return utils_jobRendererAxiosClient__WEBPACK_IMPORTED_MODULE_2__/* .jobRendererAxiosClient.get */ .V.get(carmenUrl, {
                        timeout: apiRequestTimeoutMs
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCarmenData(ip) {
        return _ref.apply(this, arguments);
    };
}();
var locationIsRemote = function(location) {
    return [
        "Flexible / Remote",
        "Remote / Flexible"
    ].map(function(a) {
        return a.toLowerCase();
    }).includes(location === null || location === void 0 ? void 0 : location.value.toLowerCase());
};


/***/ }),

/***/ 1771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getJobTrackingProps; }
/* harmony export */ });
var ref, ref1, ref2;
/**
 * getJobTrackingProps: Generate the tracking props for a single job.
 */ var getJobTrackingProps = function(job, company) {
    var ref3, ref4, ref5, ref6;
    return {
        company_id: job === null || job === void 0 ? void 0 : job.company_id,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        company_short_name: company === null || company === void 0 ? void 0 : company.short_name,
        job_applied: false,
        job_categories: (ref = job === null || job === void 0 ? void 0 : (ref3 = job.categories) === null || ref3 === void 0 ? void 0 : ref3.filter(function(x) {
            return x.value;
        }).map(function(category) {
            return category.value;
        })) !== null && ref !== void 0 ? ref : [],
        job_favorited: false,
        job_id: job === null || job === void 0 ? void 0 : job.id,
        job_level: (ref1 = job === null || job === void 0 ? void 0 : (ref4 = job.levels) === null || ref4 === void 0 ? void 0 : ref4.filter(function(x) {
            return x.value;
        }).map(function(level) {
            return level === null || level === void 0 ? void 0 : level.value;
        })) !== null && ref1 !== void 0 ? ref1 : [],
        job_locations: (ref2 = job === null || job === void 0 ? void 0 : (ref5 = job.locations) === null || ref5 === void 0 ? void 0 : ref5.map(function(location) {
            return location.value;
        })) !== null && ref2 !== void 0 ? ref2 : [],
        job_name: job === null || job === void 0 ? void 0 : job.name,
        job_short_name: job === null || job === void 0 ? void 0 : job.short_name,
        job_state: job === null || job === void 0 ? void 0 : job.state,
        job_type: job === null || job === void 0 ? void 0 : job.type,
        job_ats_name: job === null || job === void 0 ? void 0 : (ref6 = job.ats_info) === null || ref6 === void 0 ? void 0 : ref6.provider,
        placement_position: null
    };
};


/***/ }),

/***/ 7985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"companyInformationModule":"CompanyInformationModule_companyInformationModule__2M32l","companyLogo":"CompanyInformationModule_companyLogo__wvWl2","companyShortDescription":"CompanyInformationModule_companyShortDescription__Hr_fW","companyProfileLink":"CompanyInformationModule_companyProfileLink__sRyue","hasPhoto":"CompanyInformationModule_hasPhoto__k3Kxh"};

/***/ }),

/***/ 7134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobInteractionHistoryViewed":"JobApplyButton_jobInteractionHistoryViewed__tMJZ8","jobInteractionHistoryApply":"JobApplyButton_jobInteractionHistoryApply__p1U0_","jobInteractionUserData":"JobApplyButton_jobInteractionUserData__W9xvZ"};

/***/ }),

/***/ 6766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"JobIndividualBody_applyButton__XMXE4","jobBodyContainer":"JobIndividualBody_jobBodyContainer__rQGA_","framed":"JobIndividualBody_framed__Ay919","jobBodyDescription":"JobIndividualBody_jobBodyDescription__NTB3f","jobBodyFooter":"JobIndividualBody_jobBodyFooter__GRqS9","jobBodyJWPlayerVideo":"JobIndividualBody_jobBodyJWPlayerVideo__XAlZ9","perksAndBenefits":"JobIndividualBody_perksAndBenefits__Eul6J","archivedJobMessage":"JobIndividualBody_archivedJobMessage___Dywb","applyContainer":"JobIndividualBody_applyContainer__ffb_U","pulse":"JobIndividualBody_pulse__Ihqw_","archiveButton":"JobIndividualBody_archiveButton__2aexi","gradient":"JobIndividualBody_gradient__K5oEP"};

/***/ }),

/***/ 5870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"JobIndividualHeader_applyButton__Joqhj","jobHeaderContainer":"JobIndividualHeader_jobHeaderContainer__GyMg1","closeIframe":"JobIndividualHeader_closeIframe__oKRym","jobHeaderCompanyName":"JobIndividualHeader_jobHeaderCompanyName__PKqdn","jobHeaderCompanyNameProgrammatic":"JobIndividualHeader_jobHeaderCompanyNameProgrammatic__dp1zo","jobHeaderTitle":"JobIndividualHeader_jobHeaderTitle__wA3d3","jobHeaderSubHeading":"JobIndividualHeader_jobHeaderSubHeading__nRAGH","jobHeaderSeparator":"JobIndividualHeader_jobHeaderSeparator__d5Um7","jobHeaderLocation":"JobIndividualHeader_jobHeaderLocation__Tyroc","jobInteractionHistoryViewed":"JobIndividualHeader_jobInteractionHistoryViewed__zH5ZJ","archivedJobMessage":"JobIndividualHeader_archivedJobMessage__4Qvn6","archivedButton":"JobIndividualHeader_archivedButton__YrOWB","pulse":"JobIndividualHeader_pulse__TdSa0","framed":"JobIndividualHeader_framed__lr03X","archived":"JobIndividualHeader_archived___6hwa","newWindow":"JobIndividualHeader_newWindow__r_z6r","gradient":"JobIndividualHeader_gradient__6Yn0J"};

/***/ }),

/***/ 7423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"StickyHeader_applyButton__uOCoW","stickyHeader":"StickyHeader_stickyHeader__xjx97","framed":"StickyHeader_framed__LivWy","names":"StickyHeader_names__vxJIi","actions":"StickyHeader_actions__dm4s_","closeIframe":"StickyHeader_closeIframe__gXprQ","title":"StickyHeader_title__JqC1h","content":"StickyHeader_content__pLuGJ","open":"StickyHeader_open__2ZpWq","companyName":"StickyHeader_companyName__wLGf5","companyNameProgrammatic":"StickyHeader_companyNameProgrammatic__riiBR","pulse":"StickyHeader_pulse__aBguP","archiveButton":"StickyHeader_archiveButton__BO5G_","archivedJobMessage":"StickyHeader_archivedJobMessage__LnLBF","gradient":"StickyHeader_gradient__tHOMV"};

/***/ }),

/***/ 3865:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"logged_in":false,"view_bookings":false,"company":{"id":134,"name":"Test Company","short_name":"test-company"},"location":{"city":"Brooklyn","region":"New York","country":"United States","dma":"New York, NY","lat":40.7099,"lon":-73.9591,"accuracy_radius":5},"cropped_name":"Test","email":"testuser@test.com","favorite_posts":[{"id":667845,"post_id":24160},{"id":667846,"post_id":24168}],"name":"Test User","id":543536}');

/***/ })

}]);